import { useQuery } from "@tanstack/react-query";
import { RewardBonusNominal, RewardFreeSpins } from "types/Reward";
import { api } from "../utils/hostname";
import url from "../url";

const request = (ids?: string[]) =>
  api(true, true).get<{ list: Array<RewardFreeSpins | RewardBonusNominal> }>(
    url.config.api.rewards.info,
    {
      params: {
        rewardIds: ids,
      },
    },
  );

export const useGetRewardsInfo = (ids?: string[], enabled?: boolean) => {
  const localIds = ids || [];
  const { data, isLoading } = useQuery({
    queryKey: ["reward info", ...localIds],
    queryFn: () => request(localIds),
    enabled: localIds.length > 0 && enabled,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });

  return {
    rewardsInfo: data?.data?.list || [],
    isLoading,
  };
};
